import { SentimentWordConfig } from './types';

export const nlSentimentWordConfig: SentimentWordConfig = {
    positiveWords: new Set([
        'actief',
        'akkoord',
        'beter',
        'blij',
        'compleet',
        'duidelijk',
        'effectief',
        'fantastisch',
        'fijn',
        'gelukkig',
        'gezond',
        'geweldig',
        'goedgekeurd',
        'goed',
        'groei',
        'handig',
        'helder',
        'hoopvol',
        'klaar',
        'krachtig',
        'nuttig',
        'opgelost',
        'optimistisch',
        'perfect',
        'positief',
        'progressie',
        'rustig',
        'soepel',
        'stabiel',
        'sterk',
        'succes',
        'veilig',
        'verbeterd',
        'waardevol',
        'winst',
        'aangenaam',
        'behaald',
        'betrouwbaar',
        'eenvoudig',
        'energie',
        'favoriet',
        'feestelijk',
        'geliefd',
        'gerust',
        'glans',
        'helpend',
        'hersteld',
        'inspirerend',
        'lief',
        'meevaller',
        'motiverend',
        'opgeruimd',
        'opluchting',
        'orde',
        'prettig',
        'reparatie',
        'tevreden',
        'vertrouwd',
        'voldaan',
        'vooruitgang',
        'vriendelijk',
        'aanwinst',
        'behaaglijk',
        'bemoedigend',
        'beschermd',
        'betekenisvol',
        'bloeiend',
        'comfort',
        'dankbaar',
        'deugdelijk',
        'eerlijk',
        'eenvoudig',
        'energiek',
        'fleurig',
        'genegen',
        'gesteund',
        'gevierd',
        'gezellig',
        'harmonie',
        'hersteld',
        'kalmte',
        'liefde',
        'licht',
        'mooi',
        'netjes',
        'opluchtend',
        'oprecht',
        'ordelijk',
        'precieus',
        'productief',
        'repareren',
        'schitterend',
        'tevredenheid',
        'troost',
        'vertrouwen',
        'vrolijk',
        'welkom',
        'werkbaar',
        'zorgeloos',
        'standvastig',
    ]),
    negativeWords: new Set([
        'afgekeurd',
        'angstig',
        'bedreiging',
        'bezorgd',
        'geblokkeerd',
        'chaos',
        'crash',
        'crisis',
        'defect',
        'gevaar',
        'gevaarlijk',
        'haat',
        'instabiel',
        'kapot',
        'laat',
        'langzaam',
        'mislukt',
        'negatief',
        'onveilig',
        'pijn',
        'probleem',
        'ramp',
        'regressie',
        'risico',
        'slecht',
        'storing',
        'traag',
        'triest',
        'vastgelopen',
        'zwak',
        'alarm',
        'bedenkelijk',
        'beklemmend',
        'boos',
        'chaotisch',
        'dreigend',
        'ellende',
        'fout',
        'frustrerend',
        'gehinderd',
        'hachelijk',
        'hinder',
        'hopeloos',
        'irritant',
        'knelpunt',
        'kritiek',
        'kwetsbaar',
        'lastig',
        'mislukking',
        'narigheid',
        'nood',
        'onrust',
        'paniek',
        'rommelig',
        'schade',
        'somber',
        'spanning',
        'stress',
        'stroef',
        'tegenvaller',
        'uitval',
        'vast',
        'vervelend',
        'zorgelijk',
        'zwakte',
        'akelig',
        'alarmerend',
        'angst',
        'barst',
        'bedreigend',
        'benauwd',
        'beroerd',
        'beschadigd',
        'bezwaren',
        'depressief',
        'ellendig',
        'foutief',
        'gekwetst',
        'instabiliteit',
        'krap',
        'last',
        'neerslachtig',
        'nukkig',
        'onheil',
        'onjuist',
        'onnodig',
        'onprettig',
        'ontredderd',
        'paniekerig',
        'pijnlijk',
        'problematisch',
        'rood',
        'schokkend',
        'somberheid',
        'stressvol',
        'struikelblok',
        'uitputtend',
        'verlamd',
        'verontrustend',
        'wrang',
    ]),
};
